import React from 'react';
import { Loader2 } from 'lucide-react';

const ButtonApple = ({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  loading = false,
  disabled = false,
  icon: Icon,
  iconPosition = 'left',
  className = '',
  ...props
}) => {
  const baseClass = 'apple-btn';
  
  const variantClasses = {
    primary: 'apple-btn-primary',
    secondary: 'apple-btn-secondary',
    ghost: 'apple-btn-ghost',
    success: 'apple-btn-success',
    danger: 'apple-btn-danger',
    outline: 'apple-btn-outline',
  };
  
  const sizeClasses = {
    xs: 'apple-btn-xs',
    sm: 'apple-btn-sm',
    md: '',
    lg: 'apple-btn-lg',
    xl: 'apple-btn-xl',
  };

  const classes = [
    baseClass,
    variantClasses[variant] || variantClasses.primary,
    sizeClasses[size] || '',
    fullWidth ? 'apple-btn-full' : '',
    className,
  ].filter(Boolean).join(' ');

  const iconSize = {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 20,
  }[size] || 16;

  return (
    <button
      className={classes}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <>
          <Loader2 size={iconSize} className="animate-spin" />
          {children && <span>{children}</span>}
        </>
      ) : (
        <>
          {Icon && iconPosition === 'left' && <Icon size={iconSize} />}
          {children && <span>{children}</span>}
          {Icon && iconPosition === 'right' && <Icon size={iconSize} />}
        </>
      )}
    </button>
  );
};

export default ButtonApple;
